<div class="row m-0 h-100 row-container">


    <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
        <app-admin-sidebar></app-admin-sidebar>
    </div>
    <div class="col-md-10 big-area p-0">

        <div class="wrapperi">

            <div class="col-12 p-0 row m-0">
                <div class="col-1"></div>
                <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
                    <h2>Varmennusta odottavat yritykset</h2>
                    <div class="" *ngIf="businesses.length > 0; else no_business_templa">

                        <div class="accordion accordion-flush" id="businessAccordion">
                            <div *ngFor="let business of businesses; let i = index" class="accordion-item">
                              <h2 class="accordion-header" id="heading{{i}}">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i" aria-expanded="true" aria-controls="collapse{{i}}">
                                  {{ business.businessName }}
                                </button>
                              </h2>
                              <div [attr.id]="'collapse' + i" class="accordion-collapse collapse" aria-labelledby="heading{{i}}" data-bs-parent="#businessAccordion">
                                <div class="accordion-body">
                                    <div class="d-flex mt-4 mb-4 justify-content-between">
                                        <div class="d-flex">
                                            <button class="btn btn-success" data-bs-toggle="modal" data-bs-target="#acceptModal" (click)="selectBusiness(business)">Hyväksy</button>
                                        </div>
                                        <div class="d-flex">
                                            <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#rejectModal" (click)="selectBusiness(business)">Hylkää</button>
                                        </div>
                                    </div>
                                    <div class="card mb-3">
                                        <div class="card-body">
                                            <p>Käyttäjän nimi {{business.user.firstName}} {{business.user.lastName}}</p>
                                            <p>Käyttäjän email: {{business.user.email}}</p>
                                            <p>Käyttäjän puh: {{business.user.phone}}</p>
                                            <p>Käyttäjää ei löytynyt työnantajista: {{business.checks.user_was_not_found}}</p>
                                            <p>Käyttäjän syöttämä y-tunnus täsmää: {{business.checks.prh_user_vatID_matches}}</p>
                                            <p>Y-tunnusta ei löytynyt yrityksistä: {{business.checks.vatID_is_not_found_from_businesses}}</p>
                                            <p>PRH:sta löytyi vain yksi yritys: {{business.checks.prh_number_of_companies_is_one}}</p>
                                            
                                        </div>
                                    </div>
                                  <div *ngFor="let company of business.prh">
                                    <div class="card mb-3">
                                      <div class="card-header">
                                        <h5>Company Name: {{ company.businessId.value }}</h5>
                                        <p>Registration Date: {{ company.businessId.value }}</p>
                                        <p>Registration Date: {{ company.businessId.registrationDate }}</p>
                                      </div>
                                      <div class="card-body">
                                        <!-- Company Names Section -->
                                        <h6 class="card-title">Names</h6>
                                        <ul class="list-group mb-3">
                                          <li *ngFor="let name of company.names" class="list-group-item">
                                            <p><strong>Name:</strong> {{ name.name }}</p>
                                            <p><strong>Type:</strong> {{ name.type }}</p>
                                            <p><strong>Registration Date:</strong> {{ name.registrationDate }}</p>
                                            <p><strong>End Date:</strong> {{ name.endDate }}</p>
                                          </li>
                                        </ul>
                          
                                        <!-- Main Business Line Section -->
                                        <h6 class="card-title">Main Business Line</h6>
                                        <p><strong>Type:</strong> {{ company.mainBusinessLine.type }}</p>
                                        <ul class="list-group mb-3">
                                          <li *ngFor="let description of company.mainBusinessLine.descriptions" class="list-group-item">
                                            <div class="" *ngIf="description.languageCode == '1'">
                                                <p><strong>Language Code:</strong> {{ description.languageCode }}</p>
                                                <p><strong>Description:</strong> {{ description.description }}</p>
        
                                            </div>
                                          </li>
                                        </ul>
                          
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                    </div>
                    <ng-template #no_business_templa>
                        <div class="alert alert-success text-center">
                            <p class="mb-0">Ei varmennusta odottavia yrityksiä</p>
                        </div>
                    </ng-template>
                   


                <div class="col-1"></div>
            </div>

        </div>

    </div>
</div>
</div>

<div class="modal fade" id="acceptModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="exampleModalLabel">Hyväksy yritys palveluun</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                    </button>
                </div>
                <div class="modal-body">
                    <p>Täytä polkutunniste ja merkkaa onko yritys julkinen. Adminille lähetetään OTP ja käyttäjälle aktivointilinkki.</p>
                    <div class="form-floating mb-2  col-12 col-md-12 p-0">
                        <input type="text" placeholder="Polkutunniste" id="path" class="form-control">
                        <label for="path">Polkutunniste</label>
                    </div>
                    <p>Onko yritys julkinen?</p>
                    <div class="form-group
                    ps-2 col-12 row m-0 pb-4">
                        <div class=" col-12 col-md-4">
                            <div class="col-12 row
                            mt-2">
                                <div class="col-1 p-0">
                                    <input type="checkbox" id="public_leaver">
                                </div>
                                <div class="col-9">
                                    <p class="text-start
                                    m-0">Kyllä</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center mt-4">
                        <button (click)="acceptBusiness()" class="btn btn-success">
                            Hyväksy
                        </button>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn" id="close_accept" data-bs-dismiss="modal">Sulje</button>
                </div>
            </div>
        </div>
    </div>

        <div class="modal fade" id="rejectModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="exampleModalLabel">Hylkää yritys</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                    </button>
                </div>
                <div class="modal-body">
                    <p class="text-center">Järjestelmä ei lähetä hylkäyksestä ilmoitusta asiakkaalle. Järjestelmä poistaa kaikki tiedot yrityksestä.</p>
                    <div class="text-center mt-4">
                        <button (click)="rejectBusiness()" class="btn btn-danger">
                            Hylkää
                        </button>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn" id="close_reject" data-bs-dismiss="modal">Sulje</button>
                </div>
            </div>
        </div>
    </div>




